module.exports = __webpack_public_path__ + "media/images/games/k2reveal/goat-008f3548125305312f6ce15d8a2b4e4e.png";